import { TEXT } from 'locales/translations';
export function labelText(labelText, isRequired) {
  return `${labelText}${isRequired === true ? TEXT.requiredFieldIndicator : ''}`;
}
